import custom_tutorial_what_a_handsome from './custom_tutorial_what_a_handsome.mp3';
import custom_tutorial_what_a_handsome_es from './custom_tutorial_what_a_handsome_es.mp3';

const audio = {
  custom_tutorial_what_a_handsome,
  custom_tutorial_what_a_handsome_es,
};

export default audio;
